import { IMAGE_BASE_URL } from '../constants/paths';
import { Helmet } from 'react-helmet-async';
import { HeroSection, ContentWrapper } from './HeroSection';

const Hero = () => {
  const church = JSON.parse(localStorage.getItem('church')) || {};
  const heroImage = church.hero_image
    ? IMAGE_BASE_URL + church.hero_image
    : 'https://images.unsplash.com/photo-1533777857889-4be7c70b33f7?auto=format&fit=crop&w=870&q=80';

  return (
    <>
      <Helmet>
        <title>{church.church_name || 'Welcome to Our Church'}</title>
        <meta
          name="description"
          content={
            church.hero_text ||
            'Church is more than a place to attend, it is a place to call home.'
          }
        />
        <link rel="canonical" href="/" />
      </Helmet>

      <HeroSection bgImage={heroImage}>
        <ContentWrapper>
          <h1>{church.hero_text || 'Church is more than a place to attend, it is a place to call home'}</h1>
          <p>
            {church.hero_tag_line ||
              'We exist to empower disciples, lead by example and change communities for the better'}
          </p>
        </ContentWrapper>
      </HeroSection>
    </>
  );
};

export default Hero;
